export default {
	login:{
		user: 'CORREO ELECTRÓNICO',
		pass: 'CONTRASEÑA'
	},
	resetear_pass:{
		nueva_pass: 'NUEVA CONTRASEÑA',
		repetir_nueva_pass: 'REPETIR CONTRASEÑA'
	}
}